import {
    Accordion,
    Button,
    Card,
    Col,
    Container,
    Form,
    NavbarCollapse,
    Row,
    Toast,
} from "react-bootstrap";
import { faCaretDown, faCaretUp, faEye, faPen, faPrint } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcons } from "@dcam/dcam_flhealth_component_library";
import React, {
    createContext,
    useContext,
    useState,
    useEffect,
    ReactNode,
} from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { apiConfig } from "../../authConfig";
import apiClient from "../../client/ApiGetClient";
import useData from "../../hooks/useData";
import usePostData from "../../hooks/usePostData";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Console } from "console";
import AppDataTable from "../../component/AppDataTable/AppDataTable";
import {
    CaseReportFormRequest,
    ClientSearchResult,
    ClientUpdateRequest,
    DiagnosisDetail,
    SearchInfoRequest,
    SearchLabRequest,
    SelectOption,
} from "../../types";

import usePost from "../../hooks/usePost";
import useGetData from "../../hooks/useGetData";
import { AppCard } from "../../component/AppCard";
import { AppLabel } from "../../component/AppLabel";
import AppButton from "../../component/AppButton/AppButton";

import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ApiResponse } from "../Dashboard/ApiResponse";
//import ".ProviderDashboard/ProviderDashboard.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { set } from "date-fns";
import EditUser from "../UserManagement/EditUser";
import { useNavigate } from "react-router-dom";
import "./FacilityUserReview.scss";
import { faMemoCircleCheck } from "@fortawesome/pro-regular-svg-icons";


const FacilityUserReview: React.FC = () => {

    const { instance, accounts } = useMsal();
    
    const account = accounts[0];
    const [isUserFormEnable, setUserFormEnable] = useState(false);
    const [email, setUserEmail] = useState("");
    const navigate = useNavigate();

    const clickHandler= (row:any) => {
            navigate("/FacilityRegistration/Edit/"+row?.hospitalRegistrationId)
    }

    const UserColumn = [
        {
            name: <b>Facility ID</b>,
            selector: (row: any) => row.hospitalRegistrationId,
            sortable :true,
        },
        {
            name: <b>Facilirty Name</b>,
            selector: (row: any) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                {row.hospitalName}
            </div>,
            sortable :true,
            width: "280px",
        },
        {
            name: <b>Facility Type</b>,
            selector: (row: any) => row.hospitalTypeName,
            sortable :true,
            width: "200px",
        },
        {
            name: <b>County</b>,
            selector: (row: any) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                {row.countyName}
                </div>,
            sortable :true,
            width: "160px",
        },
        {
            name: <b>Status</b>,
            selector: (row: any) => {
                if (row.isApproved == null) 
                    return (
                    <span style={{
                    backgroundColor: "#FFF797", //Yellow
                    borderRadius: "50px",
                    padding: "10px",
                    color: "black",
                    fontWeight: "normal",
                    lineHeight: "1.8",
                  }}>
                    Pending
                  </span>
                  );
                if (row.isApproved == 0) return (
                 <span style={{
                    backgroundColor: "#F8D7DA", //Red
                    borderRadius: "50px",
                    padding: "10px",
                    color: "black",
                    fontWeight: "normal",
                    lineHeight: "1.8",
                  }}>
                    Rejected
                  </span>
                  );
                if (row.isApproved == 1) return (
                <span style={{
                    backgroundColor: "#DBF8DD", //Green
                    borderRadius: "50px",
                    padding: "10px",
                    color: "black",
                    fontWeight: "normal",
                    lineHeight: "1.8",
                  }}>
                    Approved
                  </span>
                  );
                return "Unknown"; // Optional: in case IsApproved has unexpected values
            },
            width: "115px",
        },
        {
            name: <b>Request Submitted By</b>,
            selector: (row: any) => row.userFirstName + " " + row.userLastName,
            sortable: true,
            width: "200px",
        },
        {
            name: <b>Submission Date</b>,
            selector: (row: any) => {
                const date = new Date(row.dateCreated);
                return date.toLocaleString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true, // For AM/PM format
                });
              },
            sortable: true,
            width: "180px",
        },
        
       
        {
            name:  <b style={{ display: "block", textAlign: "center", width: "100%" }}>Action</b>,
            selector: (row: any) => 
                <div>
                    {row.isApproved == null && (
                        <div>
                    <AppButton
                        variant={"secondary"}
                        onClick={() => navigate('/FacilityRegistration/Edit/'+row?.hospitalRegistrationId)}
                    >
                        <FontAwesomeIcon icon={faPen}/> &nbsp;
                        Edit
                    </AppButton>
                    &nbsp;
                    <AppButton variant="primary"
                        onClick={() => navigate('/FacilityRegistration/Review/'+row?.hospitalRegistrationId)}
                    >
                        <FontAwesomeIcon icon={faMemoCircleCheck} /> Review
                    </AppButton>
                    </div>
                    )}
                </div>,
            width: "250px",
        },
    ];

    const [userData, setUserData] = useState<any>();



    const { getDataById: getAllUserSecurity } = useGetData<any, string>(
        "HospitalRegistration/GetAllHospitalRegistrations",
        "GET"
      );



      const { getDataById: getUserId } = useGetData<any, string>(
        "UserSecurity/GetUserSecurityByEmail/"+account.username,
        "GET"
      );

      useEffect(() => {
        const loadData = async () => {
          const data = await getAllUserSecurity("");
          setUserData(data);
          const userData = await getUserId("");
          if (!userData?.user?.isActive) navigate('/unauthorized');
        };
        loadData();     
      }, []);

      

    const [filteredData, setFilteredData] = useState<any>([]);
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [roleName, setRoleName] = useState<string>("");


  const handleSearch = (searchValue: string) => {
    setSearchTerm(searchValue);
    const lowercasedValue = searchValue.toLowerCase();
    searchValue = searchValue.toLowerCase();
    if (!searchValue) {
        setFilteredData(userData);
      return;
    }
    
    const filtered = userData?.filter((row: any) => {
        const isApprovedText =
        row?.isApproved === null ? "Pending" :
        row?.isApproved ? "Approved" : "Rejected";
    
        return (
            row?.hospitalName?.toLowerCase().search(searchValue) >= 0 ||
             row?.hospitalTypeName?.toLowerCase().search(searchValue) >= 0 ||
             //||
              row?.countyName?.toLowerCase().search(searchValue) >= 0 ||
              row?.userFirstName?.toLowerCase().search(searchValue) >= 0 ||
              row?.userLastName?.toLowerCase().search(searchValue) >= 0 ||
              isApprovedText.toLowerCase().search(searchValue) >= 0
        );
    });

    setFilteredData(filtered);
   };

  useEffect(() => {
    const loadData = async () => {
        const data = await getAllUserSecurity("");
        setUserData(data);
        if (data) {
             // Set the original data
            setFilteredData(data); // Initialize the filtered data to show all rows initiall
        }
    };
    loadData();
   }, []);
    return (
    <>
    <Container>
       {/* {!isUserFormEnable?  */}
        <div className="full-screen-container">
            
            {/* <AppCard title="Florida Heath Care Lookup Dashboard"> */}
                
                <Row className="mb-3">
                    <Col>
                        <br></br>
                        <AppCard title="Facility Review Dashboard (Requests)" bottomMargin>
                            <Row>
                                <Col >
                                    <AppDataTable
                                        columns={UserColumn}
                                        data={filteredData}
                                        pagination={true}
                                        search={true}
                                        searchCallBack={handleSearch}
                                        //loading={isProgress}
                                        noDataComponent={undefined}
                                    />
                                </Col>
                            </Row>
                        </AppCard>
                    </Col>
                </Row>
            {/* </AppCard> */}
        </div>
        {/* :
        <EditUser email={email} onClick={handleBackButton}></EditUser>} */}
        
        </Container>
        </>
    );
};

export default FacilityUserReview;